export default __webpack_public_path__ + "static/media/bg_placeholder_square.72ff23fe.svg";